import { Component, OnInit, Input, Output, EventEmitter, isDevMode, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { UtilsService } from '../../../services/utils/utils.service';
import { PresupuestoGuardarService } from '../../../../core/providers/services/presupuesto-guardar/presupuesto-guardar.service';
import { CommonService } from 'src/app/core/providers/forms/common.service';
import { environment } from 'src/environments/environment';
import { PolizasEmitirService } from 'src/app/core/providers/services/polizas-emitir/polizas-emitir.service';
import { DocumentacionCorreoService } from 'src/app/core/providers/services/documentacion-correo/documentacion-correo.service';
import { RentedService } from 'src/app/core/providers/services/rented-home/rented-home.service';
import { MunicipiosRecuperarService } from 'src/app/core/providers/services/municipios-recuperar/municipios-recuperar.service';
import { Numbers } from 'src/app/utils/constants';
import LegalStepThreeComponentUtils from './legal-step-three-rent.component.utils';
import { ListaAseguradosAdicionalesInterface, PresupuestoGuardarInterface } from 'src/app/core/interfaces/presupuesto-guardar.interface';

@Component({
  selector: 'app-legal-step-three-rent',
  templateUrl: './legal-step-three-rent.component.html',
  styleUrls: ['./legal-step-three-rent.component.scss']
})
export class LegalStepThreeRentComponent implements OnInit, OnDestroy {

  redsysRedirectUrl: string = environment.redsysRedirectUrl;
  @ViewChild('payform', { static: false }) payForm: ElementRef;
  @ViewChild('thanksB', { static: false }) thanksB: ElementRef;
  tpvParameters: any;

  //#region Constructor
  /**
   * @ignore
   */
  constructor(
    private commons: CommonService,
    private utilsSrv: UtilsService,
    private budgetSrv: PresupuestoGuardarService,
    private polSrv: PolizasEmitirService,
    readonly emailSrv: DocumentacionCorreoService,
    private rentedSrv: RentedService,
    private municipalitySrv: MunicipiosRecuperarService,
    private gtmService: GoogleTagManagerService
  ) {
    this.polSrv = polSrv;
    this.emailSrv = emailSrv;
    this.commons = commons;
    this.utilsSrv = utilsSrv;
    this.budgetSrv = budgetSrv;
    this.rentedSrv = rentedSrv;
    this.municipalitySrv = municipalitySrv;
    this.gtmService = gtmService;
    this.utils = new LegalStepThreeComponentUtils(this.utilsSrv, this.emailSrv);
    this.emailSrv = emailSrv;
  }

  /**
   * @description Es el formulario
   */
  @Input() FORM_DATA: FormGroup;

  /**
   * @description Es la configuracion del formulario
   */
  @Input() FORM_CONFIG: any;

  /**
   * @description Es el paso del formulario
   */
  @Input() STEP: any;

  @Output() CLICK_BTN: EventEmitter<'back' | 'next'> = new EventEmitter();
  @Output() INSURED_CHOOSED: EventEmitter<'Particular' | 'Empresa'> = new EventEmitter();

  @ViewChild('zipcode', { static: false }) input: ElementRef;

  finish = new Subject();

  ownerConfig: any;
  inmuebleConfig: any;
  tenantConfig: any;
  insureSelected: string;
  currentStep = 0;
  formDataValue: any;
  public utils: any;
  public email: string;
  public polizaData: any;
  patternEmail: RegExp = this.commons.patternsForm('email');
  patternMobile: RegExp = this.commons.patternsForm('mobile');
  patternCP: RegExp = this.commons.patternsForm('cp');
  typeDocChange: { name: string, value: any };
  docNumberChange: { name: string, value: any };
  cpchange: { name: string, value: any };
  munichange: { name: string, value: any };
  provchange: { name: string, value: any };
  countrychange: { name: string, value: any };
  typeChange: { name: string, value: any };
  public displayModal2: boolean;
  idPresu = 0;
  clickBtnValue = '';
  precioProducto: number;
  showTPV = false;
  success: boolean;
  showLoader = false;
  isInvalid = true;
  rute = '/';
  imgLoader = '<img src="../../../../../assets/images/loading.gif" alt="">';
  errorDesc = '';

  /**
   * @ignore
   */
  ngOnInit() {
    this.currentStep = this.STEP;
    this.getProductChoosed();
    this.initSubs();
    this.utils.setValidator(this.FORM_DATA, this.ownerConfig, this.inmuebleConfig,
      this.tenantConfig, this.FORM_CONFIG, this.patternCP, this.patternEmail);
    this.FORM_DATA = this.utils.formDataUtils;
    window.scrollTo(0, 0);
  }
  /**
   * @ignore
   */
  ngOnDestroy() {
    this.finish.next(true);
  }
  /**
   * @description Definición inicial del paso
   */
  initSubs(): void {
    this.formDataValue = this.FORM_DATA.get(this.insureSelected).value;
    this.ownerConfig = this.FORM_CONFIG.insuredListData.owner;
    this.inmuebleConfig = this.FORM_CONFIG.insuredListData.inmueble;
    this.tenantConfig = this.FORM_CONFIG.insuredListData.tenant;

    this.FORM_DATA.get(this.insureSelected).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(() => {
          this.formDataValue = this.FORM_DATA.get(this.insureSelected).value;

          setTimeout(() => {
            const auxForm: AbstractControl = this.FORM_DATA.get(this.insureSelected);
            this.isInvalid = true;
            if (auxForm.valid) { this.isInvalid = false; }
          }, Numbers.number100);
        })
      ).subscribe();
  }
  /**
   * @description botón siguiente o anterior
   */
  public clickButton(ev: 'back' | 'next'): void {
    if (ev === 'next') {
      this.clickBtnValue = 'next';
      if (this.FORM_DATA.valid) {
        this.callPresupuestoGuardar();
      } else {
        const formValues: any = this.FORM_DATA.get(this.insureSelected).value;
        const acceptTerms: any = formValues.domiciliation.acceptTerms;
        if (acceptTerms === false) {
          this.utils.showModalTerms();
        }
      }
    } else {
      this.clickBtnValue = 'back';
      localStorage.removeItem('stepThanks');
      this.utils.removeValidator(this.FORM_DATA, this.ownerConfig, this.inmuebleConfig, this.tenantConfig, this.FORM_CONFIG);
      this.FORM_DATA = this.utils.formDataUtils;
      this.CLICK_BTN.emit(ev);
    }
  }

  /**
   * @description Recupera el tipo de tomador: Particular o Empresa
   */
  getTypeOwner(): 'Particular' | 'Empresa' {
    if (this.FORM_DATA) {
      return this.FORM_DATA.get(this.FORM_CONFIG.insuredData.typeOwner.linkFormPath).value;
    }
  }
  /**
   * @description Devuelve los valores informados en el tomador y los asigna al asegurado
   */
  setInsureSameOfOwner(): void {
    if (this.FORM_DATA && this.FORM_CONFIG) {
      const values: any = {
        documentType: this.FORM_DATA.get(this.FORM_CONFIG.insuredData.documentType.linkFormPath).value,
        documentNumber: this.FORM_DATA.get(this.FORM_CONFIG.insuredData.documentNumber.linkFormPath).value,
        name: this.FORM_DATA.get(this.FORM_CONFIG.insuredData.particular.name.linkFormPath).value,
        firstSurname: this.FORM_DATA.get(this.FORM_CONFIG.insuredData.firstSurname.linkFormPath).value,
        secondSurname: this.FORM_DATA.get(this.FORM_CONFIG.insuredData.secondSurname.linkFormPath).value
        // email: this.FORM_DATA.get(this.FORM_CONFIG.insuredData.email.linkFormPath).value
      };

      this.FORM_DATA.get(this.ownerConfig.documentType.linkFormPath).setValue(
        { name: values.documentType.name, id: values.documentType.id });
      this.FORM_DATA.get(this.ownerConfig.documentNumber.linkFormPath).setValue(values.documentNumber);
      this.FORM_DATA.get(this.ownerConfig.name.linkFormPath).setValue(values.name);
      this.FORM_DATA.get(this.ownerConfig.firstSurname.linkFormPath).setValue(values.firstSurname);
      this.FORM_DATA.get(this.ownerConfig.secondSurname.linkFormPath).setValue(values.secondSurname);
      // this.FORM_DATA.get(this.ownerConfig.email.linkFormPath).setValue(values.email);
      this.typeDocChange = { name: 'typeDoc', value: values.documentType };
    }
  }
  /**
   * @description retorna si se muestra el modal CP
   */
  public getModalState(): boolean {
    return this.utils.showModal;
  }
  /**
   * @description modal TPV
   */
  showModalDialog2(): void {
    this.displayModal2 = true;
  }

  /**
   * @description enter en campo CP, lanzando búsqueda en servicio
   */
  dataEmit(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if (Object.keys(ev).length > 0) { keyPress = ev; }
      if (keyPress !== null && keyPress.enter !== undefined && keyPress.enter) {
        const auxValue: any = this.FORM_DATA.get(this.inmuebleConfig.postalCode.linkFormPath).value;
        this.getMunicipality(auxValue);
      }
    }
  }

  /**
   * @description blur en input CP, lanzando búsqueda en servicio
   */
  dataEmitBlur(): void {
    const auxOriginValue: any = this.formDataValue.countryOriginEnvironment;
    const auxValue: any = this.FORM_DATA.get(this.inmuebleConfig.postalCode.linkFormPath).value;
    if (auxOriginValue === Numbers.number19001 && (auxValue === 0 || auxValue === '0')) {
      this.cpchange = { name: 'cp', value: 'error-spain' };
    } else {
      if (auxValue === '') {
        this.cpchange = { name: 'cp', value: 'error-empty' };
      }
    }
  }

  /**
   * @description recuperar los valores del servicio municipio
   */
  getMunicipality(code: number): void {
    this.municipalitySrv.getMunicipality(code)
      .pipe(take(1))
      .subscribe((municipality: any) => {
        if (municipality !== null && municipality.length > 1 ) {
          this.munichange = { name: 'municipio-list', value: municipality };
        } else if (municipality !== null) {
          this.munichange = { name: 'municipio', value: municipality[0] };
          this.provchange = { name: 'provincia', value: municipality[0].Des_Provincia };
          this.countrychange = { name: 'country', value: '' };
          this.FORM_DATA.get([this.insureSelected, 'insuredListData', 'inmueble', 'provinceId']).setValue(municipality[0].Id_Provincia);
        } else {
          this.cpchange = { name: 'cp', value: 'error' };
          this.FORM_DATA.get([this.insureSelected, 'insuredListData', 'inmueble', 'provinceId']).setValue(0);
          this.utils.showModalDialog();
        }
      });
  }
  /**
   * @description cambiar municipio
   * @params event
   */
    changeMuni(event: any): void {
      if (event.Des_Provincia !== undefined) {
        this.provchange = { name: 'provincia', value: event.Des_Provincia };
        this.countrychange = { name: 'country', value: 'España' };
        this.FORM_DATA.get([this.insureSelected, 'insuredData', 'municipality'])
          .setValue({ name: event.Des_Municipio, id: event.Id_Municipio });
        this.FORM_DATA.get([this.insureSelected, 'insuredData', 'provinceId']).setValue(event.Id_Provincia);
      }
    }

  /**
   * @description Generar presupuesto a guardar
   */
  callPresupuestoGuardar(): void {
    let idProveedorWeb = 1;
    let auxIdProduct: number = Numbers.number17094;
    if (this.formDataValue.insuranceType.priority === 0) { auxIdProduct = Numbers.number17093; }
    const dateToday: string = this.utilsSrv.getDateToday();
    const numberOfInsureds: any = this.formDataValue.numberOfInsured;
    const procedenciaV = 'WEB';
    const idPortalV = '1';
    let expatriadoV = true;
    if (this.insureSelected === 'ownerLegalAsistance') { expatriadoV = false; }
    if (this.formDataValue.idCorreduria !== '') {
      idProveedorWeb = this.formDataValue.idCorreduria;
    } else {
      idProveedorWeb = 1;
    }

    const viajerosBase: any = {
      idPresupuesto: 0,
      ambitoOrigen: this.formDataValue.countryOriginEnvironment,
      ambitoDestino: this.formDataValue.countryDestinyEnvironment,
      expatriado: expatriadoV,
      numDias: this.formDataValue.insuranceTime
    };
    const viajerosNormales: any = {
      ...viajerosBase,
      numViajeros: numberOfInsureds,
      idSobrePrima: 0
    };
    const obj: PresupuestoGuardarInterface = {
      idProducto: auxIdProduct,
      fecEfecto: this.utilsSrv.changeDateOrderToService(this.formDataValue.dateStart),
      fecVencimiento: this.utilsSrv.changeDateOrderToService(this.formDataValue.dateEnd),
      listaViajeros: [
        viajerosNormales
      ],
      precioPresupuesto: this.formDataValue.insuranceType.price,
      // Id_proveedor: 1,
      idProveedor: idProveedorWeb,
      tomadorPresupuesto: this.utils.tomadorPres(this.formDataValue),
      indCondiciones: 1,
      emNombre: '',
      emApe1: '',
      emApe2: '',
      emRelacionAsegurado: '',
      emTel1: '',
      desDescuento: this.formDataValue.codePromotional,
      listaAseguradosAdicionales: this.utils.aditionalPres(this.formDataValue),
      procedencia: procedenciaV,
      fecTarificacion: dateToday,
      derogaciones: [],
      descuentoMediador: 0,
      nombrePresupuesto: 'Proyecto',
      accion: 0,
      idPresupuestoActualizar: 0,
      viajesPersonales: 0,
      idPortal: idPortalV,
      idComercial: 0,
      garantias: this.utils.getGarantees(this.formDataValue),
      idModalidad: 1,
      idAmbitoOrigen: this.formDataValue.countryOriginEnvironment,
      idAmbitoDestino: +this.formDataValue.countryDestinyEnvironment,
      indReceptivo: false,
      unidadFamiliar: false,
      idFraccionamientoPago: 0,
      slCodigoAgencia: '',
      slComision: '',
      slDistrito: '',
      slMonitor: '',
      slNifAuxiliarExterno: '',
      slZona: '',
      idRedProduccion: '12',
      listadoConsentimientos: this.utils.consentimientosPresu(this.formDataValue),
      renta: this.formDataValue.monthlyRent,
      indRenovacionAuto: true,
      idSubtipoPoliza: Numbers.number2,
      idTipoRenovacionAsegurado: Numbers.number2,
      indRenovableTemporal: true,
      indPolizaMarco: false,
      tipoCobertura: this.utils.getCoverageType(),
      numOpcionContratacion: Numbers.number2,
      idSobreprima: 0,
      listaPaises: [],
      deporte: [],
      AutorizadoFirma: true
    };
    const presu: PresupuestoGuardarInterface = obj;
    this.showLoader = true;
    this.budgetSrv.postBudgetSave(presu)
      .pipe(take(1))
      .subscribe((budgetSaved: any) => {
        this.idPresu = 0;
        if (budgetSaved.idError !== 0) {
          this.errorDesc = budgetSaved.desError;
        } else {
          this.errorDesc = '';
        }
        if (budgetSaved.idPresupuesto !== undefined) { this.idPresu = budgetSaved.idPresupuesto; }
        if (this.idPresu > 0) {
          localStorage.setItem('email', this.formDataValue.insuredData.email);
          this.domicilioalquilado();
        }
      });
  }

  /**
   * @description Recupera las condiciones adicionales del presupuesto
   */
  getInsuredListAdditional(): ListaAseguradosAdicionalesInterface[] {
    const insured: any = this.formDataValue.insuredData;
    const fillProperties: ListaAseguradosAdicionalesInterface[] = [{
      idAsegurado: 0,
      nombreAsegurado: insured.name,
      apellido1Asegurado: insured.firstSurname,
      apellido2Asegurado: insured.secondSurname,
      nifAsegurado: insured.documentNumber,
      fechaNacimientoAsegurado: '',
      ambitoOrigen: this.formDataValue.countryOriginEnvironment,
      ambitoDestino: this.formDataValue.countryDestinyEnvironment,
      tipoCoberturaAsegurado: this.utils.getCoverageType(), // Temporal / Anual_+90 / Anual larga estancia
      fecEfecto: this.utilsSrv.changeDateOrderToService(this.formDataValue.dateStart),
      fecVencimiento: this.utilsSrv.changeDateOrderToService(this.formDataValue.dateEnd),
      idSobrePrimaAsegurado: 0,
      desDescuento: this.formDataValue.codePromotional,
      email: insured.email,
      idTipoDescuento: 0,
      fecTarificacion: this.utilsSrv.getDateToday(),
      idPoliza: 0
    }];
    return fillProperties;
  }

  /**
   * @description Se asigna y envía los datos del domicilio alquilado
   */
  domicilioalquilado(): void {
    let renta1: any = this.formDataValue.monthlyRent;
    if (this.formDataValue.monthlyRent === '') { renta1 = 0; }
    // rentedSrv
    const data: any = {
      idPresu: this.idPresu,
      idDomicilio: 1,
      direction: this.formDataValue.insuredListData.inmueble.direction,
      cp: this.formDataValue.insuredListData.inmueble.postalCode,
      idProvincia: this.formDataValue.insuredListData.inmueble.provinceId,
      idMunicipio: this.formDataValue.insuredListData.inmueble.municipality.id,
      renta: renta1,
      direccionInquilino: '',
      cpInquilino: '',
      idProvinciaInquilino: '',
      idMunicipioInquilino: '',
      nombreInquilino: this.formDataValue.insuredListData.tenant.name,
      apellido1Inquilino: this.formDataValue.insuredListData.tenant.firstSurname,
      apellido2Inquilino: this.formDataValue.insuredListData.tenant.secondSurname,
      tipoNif: this.formDataValue.insuredListData.tenant.documentType.id,
      nif: this.formDataValue.insuredListData.tenant.documentNumber
    };
    this.rentedSrv.domicilioalquilado(data)
      .pipe(take(1))
      .subscribe((sendPol: any) => {
        let auxSend = false;
        if (sendPol.idError !== undefined && sendPol.idError === 200) { auxSend = true; }
        if (auxSend) {
          this.emitPolicy();
        }
      });
  }
  /**
   * @description Se emite la poliza
   */
  emitPolicy(): void {
    const data: any = {
      idPresupuesto: this.idPresu,
      documento: this.formDataValue.insuredData.documentNumber,
      email: this.formDataValue.insuredData.email,
      numeroConfirmacion: '000000',
      codigoVenta: '0000',
      tieneAsegurados: false
    };
    this.utils.datalayer2(this.FORM_DATA, this.gtmService);
    this.utils.datalayer(this.idPresu, parseFloat(this.formDataValue.insuranceType.price), this.FORM_DATA, this.gtmService);
    this.polSrv.postPolicySend(data, true)
      .pipe(take(1))
      .subscribe((sendPol: any) => {
        let auxSend = false;
        if (sendPol.idError !== undefined && sendPol.idError === 0) { auxSend = true; }
        if (auxSend) {
          this.polizaData = sendPol;
          this.sendEmail();
        } else {
          localStorage.setItem('stepThanks', 'true');
          this.utils.setStepThanks();
          this.success = false;
          localStorage.removeItem('budget');
        }
      });

    localStorage.removeItem('budget');
  }

  /**
   * sendEmail
   * @param email email
   */
  sendEmail(): void {
   this.email = localStorage.getItem('email');
   const a: any = {
      idPoliza: this.polizaData.idPoliza,
      indEmail: true,
      email: this.email
    };
   this.emailSrv.postDocumentationEmail(a)
      .pipe(take(1))
      .subscribe((emailD: any) => {
        localStorage.removeItem('stepThanks');
        this.success = true;
        localStorage.setItem('stepThanks', 'true');
        this.CLICK_BTN.emit('next');
      });
  }

  /**
   * getProductChoosed
   */
  getProductChoosed(): void {
    if (this.FORM_DATA) {
      this.insureSelected = this.FORM_DATA.get('insureSelected').value.chosed;
    }
  }

  /**
   * Transform the email to lowerCase
   */
    transformLower(): void {
      const LOWER: string = this.FORM_DATA.get(this.ownerConfig.email.linkFormPath).value.toString().toLowerCase();
      this.FORM_DATA.get(this.ownerConfig.email.linkFormPath).setValue(LOWER);
    }
}
